export default "__VITE_ASSET__DJqGSLxs__"